import PropTypes from 'prop-types'

const GraphOffsetPropType = PropTypes.arrayOf(PropTypes.number)

export default GraphOffsetPropType
